module.exports = __webpack_public_path__ + "static/media/500-error.26ac0aba.png";